// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/ErrorForceRefresh.scss
// module id = 2184
// module chunks = 0